export default {
  methods: {
    showAction (item, type) {
      return item?.conversionCountByType && item?.conversionCountByType[type] > 0
    }
  }
}
